/**
 * HTMX bootstrap for bundled builds (htmx 2.x).
 *
 * htmx 2.x's `htmx.min.js` is `var htmx = (function(){...})()` — a module-scoped
 * variable with NO export and NO global assignment. As a classic <script> (dev
 * mode) that top-level `var` becomes window.htmx automatically, but inside
 * esbuild's bundle it is trapped in module scope with nothing to import, leaving
 * window.htmx undefined (which silently disables the SSE extension + every
 * window.htmx-dependent module). The ESM build `htmx.esm.js` has a proper
 * `export default htmx`, so import THAT for the bundle and expose it on
 * window/globalThis BEFORE the SSE extension (sse.js) is imported, so the
 * extension registers on the same instance that processes the DOM.
 */
import htmx from '../static/js/htmx.esm.js';

window.htmx = htmx;
if (typeof globalThis !== 'undefined') {
  globalThis.htmx = htmx;
}

export default htmx;
